import {IExtraGroupByContentField} from '@stores'
import {useGroupByGroupStore} from './'
import {_, classNames, React, useEffect, observer, Fragment} from '@api'
import css from './GroupByGroupCardContentsExtra.css'

export const GroupByGroupCardContentsExtra = observer(() => {
  const store = useGroupByGroupStore(),
    {
      grouping: {fieldDefinition}
    } = store,
    inlineContent = (fieldDefinition?.group?.custom?.extraHeaderCardContent ?? []).filter(f => f.position === 'inline')

  if (_.isEmpty(inlineContent)) {
    return null
  }

  return (
    <Fragment>
      {inlineContent.map(({fields, rows}, i) => {
        return (
          <div className={classNames(css.root)}
               data-type='GroupByGroupCardContentsExtra'
               key={i}
               >
            {(fields.map((f, j) => <GroupByGroupContentExtraField field={f} key={j} />))}
          </div>
        )
      })}
    </Fragment>)
})

const GroupByGroupContentExtraField = observer<{field: IExtraGroupByContentField}>(({field: {id, label, value}}) => {
  const store = useGroupByGroupStore(),
    {stores} = store

  return (
    <div className={css.field}
         data-type='field'
         data-id={id}
    >
      {label && <div className={css.label} data-type='label'>{_.isString(label) ? label : label(store, stores)}</div>}
      {value && <div className={css.value} data-type='value'>{_.isString(value) ? value : value(store, stores)}</div>}
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupCardContentsExtra.tsx